export const trackViewPromotion = (promotion, index) => {
  if (!promotion) return
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "view_promotion",
      promotion_id: String(promotion.positionId),
      promotion_name: promotion.layoutName,
      creative_slot: `Homepage Banner_${index}`
    })
  }
}
export const trackSelectPromotion = (promotion, index) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "select_promotion",
      promotion_id: String(promotion.positionId),
      promotion_name: promotion.layoutName,
      creative_slot: `Homepage Banner_${index}`
    })
  }
}
